const Apipaths =  {
    BASE_URL : process.env.REACT_APP_BASE_URL_ROUTE,
    GetCaptcha:'/srmw/GenerateCaptcha',
    SendOTP : '/srmw/SendOTP',
    ValidateOTP:'/srmw/ValidateOTP',
    Enrollment:'/srmw/Enrollment',
    SSOConfiguration:'/srmw/SSOConfiguration',
    ValidateUserToken:'/srmw/ValidateUserToken',
    ValidateLink:'/srmw/ValidateLink',
    RewardEnrollment:'/srmw/RewardEnrollment',
    Logout:'/srmw/RevokeUserToken',
    MemberMigration:'/srmw/MemberMigration',
    ValidateToken:'/srmw/ValidateToken'
}
export default Apipaths